import { SagaIterator } from 'redux-saga';
import * as websocket from './externalCalendar.websocket';
import * as ExternalCalendarAction from "./externalCalendar.actions"
import { call, put } from 'redux-saga/effects';
import { IExternalCalenderEvent } from '@app-types/api/externalCalendar.types';
import { parseICSFromURL } from '@helpers/parseICS';

export function* saveExternalCal(action: any): SagaIterator {
  try {
    websocket.saveExternalCalendar(action.payload);
  } catch (error) {
    console.error(error);
  }
}

export function* updateExternalCal(action: any): SagaIterator {
  try {
    websocket.updateExternalCalendar(action.payload);
  } catch (error) {
    console.error(error);
  }
}

export function* deleteExternalCalendar(action: any): SagaIterator {
  try {
    websocket.deleteExternalCalendar(action.payload);
  } catch (error) {
    console.error(error);
  }
}
 

export function* downloadICS(action: any): SagaIterator {
  try {
      const { id, url } = action.payload;
      const response:any = yield call(parseICSFromURL, url, true);

      if (!response) {
          console.error('Invalid ICS response:', response);
          return;
      }

      const events: IExternalCalenderEvent[] = response.map((event:any) => ({
        ...event,
        calendarId: id.toString(),
    }));

    if (events.length > 0) {
        yield put(
            ExternalCalendarAction.saveFetchedEvents({
                calendarId: id.toString(),
                events,
            })
        );
    }
 
  } catch (error) {
      console.error(error);
  }
}




// WEBPACK FOOTER //
// ./src/services/externalCalendar/externalCalendar.saga.ts